// Device - connections
export const CONNECT = 'CONNECT'
// {type:CONNECT}
export const DISCONNECT = 'DISCONNECT'
// {type:DISCONNECT}
export const RECONNECT = 'RECONNECT'
// {type:RECONNECT}
export const STATUS_MESSAGE = 'STATUS_MESSAGE'
// {type:STATUS_MESSAGE, status: 'connected'}
export const SET_DARK_MODE = 'SET_DARK_MODE'
// {type:SET_DARK_MODE, isDarkMode: true}

// Device - get device firmware
export const REQUEST_FIRMWARE_VERSION = 'REQUEST_FIRMWARE_VERSION' // request fw/bl from device
// {type:REQUEST_FIRMWARE_VERSION, error: false}
export const SET_FIRMWARE_VERSION = 'SET_FIRMWARE_VERSION'
// {type:REQUEST_FIRMWARE_VERSION, versions: {firmware: "0.0.0.0", bootloader: "0.0.0.0"}}
export const FETCH_FIRMWARE_VERSION = 'FETCH_FIRMWARE_VERSION'
// {type:FETCH_FIRMWARE_VERSION}
export const SET_AVAILABLE_FIRMWARE = 'SET_AVAILABLE_FIRMWARE'
// {type:SET_AVAILABLE_FIRMWARE, version: version}
export const SET_FIRMWARE_UPDATE_AVAILABLE = 'SET_FIRMWARE_UPDATE_AVAILABLE'
// {type:SET_FIRMWARE_UPDATE_AVAILABLE, updateable: false}

// Device - Firmware Updating
export const DEVICE_UPDATE_FIRMWARE = 'DEVICE_UPDATE_FIRMWARE'
// {type:DEVICE_UPDATE_FIRMWARE, error: true}
export const UPDATE_FIRMWARE = 'UPDATE_FIRMWARE'
// {type:UPDATE_FIRMWARE, error: false}
export const FETCH_FIRMWARE = 'FETCH_FIRMWARE'
// {type:FETCH_FIRMWARE}
export const SEND_FIRMWARE = 'SEND_FIRMWARE'
// {type:SEND_FIRMWARE}
export const DEVICE_ENTER_BOOTLOADER = 'DEVICE_ENTER_BOOTLOADER'
// {type:DEVICE_ENTER_BOOTLOADER}
export const BOOTLOADER_READY = 'BOOTLOADER_READY'
// {type:BOOTLOADER_READY}
export const SET_BOOTLOADER_MODE = 'SET_BOOTLOADER_MODE'
// {type:SET_BOOTLOADER_MODE, active: true}
export const BOOTLOADER_DISCONNECT = 'BOOTLOADER_DISCONNECT'
// {type:BOOTLOADER_DISCONNECT}

export const FIRMWARE_UPDATE_COMPLETE = 'FIRMWARE_UPDATE_COMPLETE'
// {type:FIRMWARE_UPDATE_COMPLETE}

// Device - Global
export const DEVICE_REQUEST_FIRMWARE_VERSIONS = 'DEVICE_REQUEST_FIRMWARE_VERSIONS'
//{type:DEVICE_REQUEST_FIRMWARE_VERSIONS}:  KBoard.getFirmwareVersion()
export const DEVICE_REQUEST_PRESET = 'DEVICE_REQUEST_PRESET'
//{type:DEVICE_REQUEST_PRESET}:  KBoard.getPreset()
export const DEVICE_SAVE_PRESET_TO_MEMORY = 'DEVICE_SAVE_PRESET_TO_MEMORY'
//{type:DEVICE_SAVE_PRESET_TO_MEMORY}:  KBoard.savePreset()
export const DEVICE_SEND_PRESET_TO_BUFFER = 'DEVICE_SEND_PRESET_TO_BUFFER'
//{type:DEVICE_SEND_PRESET_TO_BUFFER}:  KBoard.sendPreset(preset)

// Editor
export const SET_AVAILABLE_EDITOR = 'SET_AVAILABLE_EDITOR'
// {type:SET_AVAILABLE_EDITOR, version: version}
export const SET_EDITOR_UPDATE_AVAILABLE = 'SET_EDITOR_UPDATE_AVAILABLE'
// {type:SET_EDITOR_UPDATE_AVAILABLE, updateable: false}
export const NETWORK_CONNECTION = 'NETWORK_CONNECTION'
// {type:NETWORK_CONNECTION, state: true}
export const ONLINE = 'ONLINE'
// {type:ONLINE}
export const OFFLINE = 'OFFLINE'
// {type:OFFLINE}
export const IS_ELECTRON = 'IS_ELECTRON'
// {type:IS_ELECTRON state: false}

// Device Sync
export const OPEN_DEVICE_SYNC = 'OPEN_DEVICE_SYNC'

// MIDI Thru
export const SET_MIDI_THRU = 'SET_MIDI_THRU'
// {type:SET_MIDI_THRU, portname: 'port'}
export const REFRESH_THRU_PORTS = 'REFRESH_THRU_PORTS'
// {type:REFRESH_THRU_PORTS }

// Editor Preferences
export const OPEN_PREFERENCES = 'OPEN_PREFERENCES'
// {type:OPEN_PREFERENCES}
export const SET_PREFERENCE_TOOLTIPS = 'SET_PREFERENCE_TOOLTIPS'
// {type:SET_PREFERENCE_TOOLTIPS, active: active}

// Current Preset
export const SET_CURRENT_PRESET = 'SET_CURRENT_PRESET'
// {type: SET_CURRENT_PRESET, preset: preset}
export const TOGGLE_MPE = 'TOGGLE_MPE'
// {type: TOGGLE_MPE}
export const SET_MPE_MEMBER_CHANNELS = 'SET_MPE_MEMBER_CHANNELS'
// {type: SET_MPE_MEMBER_CHANNELS, channels: 1}
export const SET_MIDI_CHANNEL = 'SET_MIDI_CHANNEL'
// {type: SET_MIDI_CHANNEL, channel: channel}
export const SET_PRESSURE_CC = 'SET_PRESSURE_CC'
// {type: SET_PRESSURE_CC, cc: cc}
export const SET_TILT_CC = 'SET_TILT_CC'
// {type: SET_TILT_CC, cc: cc}
export const SET_BEND_RANGE_PAD = 'SET_BEND_RANGE_PAD'
// {type: SET_BEND_RANGE_PAD, range: range}
export const SET_BEND_RANGE_TILT = 'SET_BEND_RANGE_TILT'
// {type: SET_BEND_RANGE_TILT, range: range}
export const SET_VELOCITY_SENSITIVITY = 'SET_VELOCITY_SENSITIVITY'
// {type: SET_VELOCITY_SENSITIVITY, sensitivity: sensitivity}
export const SET_PRESSURE_SENSITIVITY = 'SET_PRESSURE_SENSITIVITY'
// {type: SET_PRESSURE_SENSITIVITY, sensitivity: sensitivity}
export const SET_TILT_SENSITIVITY = 'SET_TILT_SENSITIVITY'
// {type: SET_TILT_SENSITIVITY, sensitivity: sensitivity}

// Current Preset: Preferences
export const SET_VELOCITY_CURVE = 'SET_VELOCITY_CURVE'
// {type: SET_VELOCITY_CURVE, curve: 'linear'}
export const SET_PRESSURE_DISABLED_RETURN = 'SET_PRESSURE_DISABLED_RETURN'
// {type: SET_PRESSURE_DISABLED_RETURN, value: -1}
export const SET_TILT_DISABLED_RETURN = 'SET_TILT_DISABLED_RETURN'
// {type: SET_TILT_DISABLED_RETURN, value: -1}
export const SET_ON_THRESHOLD = 'SET_ON_THRESHOLD'
// {type: SET_ON_THRESHOLD, threshold: 10}

export const REVERT_PRESET = 'REVERT_PRESET'
// {type: REVERT_PRESET}
export const REVERT_SENSITIVITIES = 'REVERT_SENSITIVITIES'
// {type: REVERT_SENSITIVITIES}
export const REVERT_PREFERENCES = 'REVERT_PREFERENCES'
// {type: REVERT_PREFERENCES}
